import { createStore } from 'zustand';

import { StoreType } from './types';
import { getRequestFunctionByCurrentState } from './utils';

export const favoriteGamesStore = createStore<StoreType>((set, get) => ({
  mainStore: new Map(),
  blockedActionsStore: new Set(),

  deleteItemFromBlockedActionsStore: (id) => {
    const { blockedActionsStore } = get();
    const updatedStore = new Set(blockedActionsStore);
    updatedStore.delete(id);
    set({ blockedActionsStore: updatedStore });
  },

  setValueToMainStore: (id, value) => {
    const { mainStore } = get();
    const newMainStore = new Map(mainStore);
    newMainStore.set(id, value);
    set({ mainStore: newMainStore });
  },

  revertItemValue: (id) => {
    const { mainStore, setValueToMainStore } = get();
    const valueToRevert = mainStore.get(id);

    if (valueToRevert !== undefined) {
      setValueToMainStore(id, !valueToRevert);
    }
  },

  toggleFavorite: ({ gameId, currentState, deleteRequest, addRequest }) => {
    const {
      blockedActionsStore,
      deleteItemFromBlockedActionsStore,
      revertItemValue,
      setValueToMainStore
    } = get();

    const isActionBlocked = blockedActionsStore.has(gameId);

    if (isActionBlocked) return;

    setValueToMainStore(gameId, !currentState);

    blockedActionsStore.add(gameId);

    const callRequest = getRequestFunctionByCurrentState(currentState, addRequest, deleteRequest);

    callRequest({ game_id: gameId })
      .then(() => {
        deleteItemFromBlockedActionsStore(gameId);
      })
      .catch(() => {
        deleteItemFromBlockedActionsStore(gameId);
        revertItemValue(gameId);
      });
  }
}));
